import { Pipe, PipeTransform } from '@angular/core';
import { NotificationModel } from '../model/notification.model';

@Pipe({
  name: 'filterByReadType'
})
export class NotificationFilterPipe implements PipeTransform {
    transform(notifications: NotificationModel[], readType: 'all' | 'unread', isLoading: boolean): any[] {
        if (!notifications) notifications = [];

        let filtered = notifications;
        if (readType === 'unread') {
            filtered = notifications.filter(n => !n.read);
        }

        if (isLoading) {
            return [...filtered, null];
        }

        return filtered;
    }
}
